import { routeHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/by/privacy-policy")({
  head: () => routeHead('Палітыка прыватнасці — AGAPE', 'Даведайцеся, як AGAPE абараняе і апрацоўвае асабістыя даныя.', '/by/privacy-policy'),
  component: PrivacyPolicy,
});
